import ConnectionSpec from "model/api/ConnectionSpec.model";
import ProjectSpec from "model/api/ProjectSpec.model";
import SessionInfo from "model/api/SessionInfo.model";
import ProjectModel from "model/Project.model";
import { UserLoginInfo } from "model/UserLoginInfo.model";
import { setDemoDatasources } from "slice/demo/DemoDatasourceSlice";
import { setDemoProjects } from "slice/demo/DemoProjectSlice";
import { setDemoSessions } from "slice/demo/DemoSessionSlice";
import { ConfigCatFeatureFlag } from "util/CommonConstant";
import { getLocalStorage } from "util/CommonUtil";
import { LOCAL_STORAGE } from "util/Constant";
import store from "../store";

class HelperService {
  getUserInfo() {
    if (getLocalStorage(LOCAL_STORAGE.USER_INFO))
      return JSON.parse(getLocalStorage(LOCAL_STORAGE.USER_INFO));

    return false;
  }
  getCurrentUser() {
    if (getLocalStorage(LOCAL_STORAGE.CURRENT_USER))
      return JSON.parse(getLocalStorage(LOCAL_STORAGE.CURRENT_USER));

    return false;
  }

  hasValidToken() {
    if (getLocalStorage(LOCAL_STORAGE.USER_INFO)) {
      const tolerance = 60;
      const userInfo: UserLoginInfo = JSON.parse(getLocalStorage(LOCAL_STORAGE.USER_INFO));
      return (
        userInfo.accessToken &&
        (userInfo.expiresIn ?? 0) - tolerance >
          Math.floor((new Date().getTime() - (userInfo.loggedInTime ?? 0)) / 1000)
      );
    }

    return false;
  }

  getHeadersWithAuth() {
    return {
      Authorization: "Bearer " + this.getUserInfo().accessToken,
      "Content-Type": "application/json",
      "X-Client-Identifier": "web-app",
    };
  }
  getHeadersWithAuthWithMultipartFormData() {
    return {
      Authorization: "Bearer " + this.getUserInfo().accessToken,
      "content-type": "multipart/form-data",
      "X-Client-Identifier": "web-app",
    };
  }

  getHeadersWithOnlyToken() {
    return {
      Authorization: "Bearer " + this.getUserInfo().accessToken,
      "X-Client-Identifier": "web-app",
    };
  }
  getHeaders(contentType?: string): object {
    return {
      "content-type": contentType ?? "application/json",
      "X-Client-Identifier": "web-app",
    };
  }

  getCurrentProjectInfo(): ProjectModel | null {
    const reduxState = store?.getState();
    if (reduxState.project.selectedProject) {
      return reduxState.project.selectedProject;
    }

    return null;
  }

  getDemoDatasources(): ConnectionSpec[] {
    const reduxState = store?.getState();
    if (reduxState.demoDatasource.datasources) {
      return reduxState.demoDatasource.datasources;
    }

    return [];
  }

  saveDemoDatasources(datasources: ConnectionSpec[]) {
    store.dispatch(setDemoDatasources(datasources));
  }

  getDemoProjects(): ProjectSpec[] {
    const reduxState = store?.getState();
    if (reduxState.demoProject.projects) {
      return reduxState.demoProject.projects;
    }

    return [];
  }

  saveDemoProjects(projects: ProjectSpec[]) {
    store.dispatch(setDemoProjects(projects));
  }

  getDemoSessions(): SessionInfo[] {
    const reduxState = store?.getState();
    if (reduxState.demoSession.sessions) {
      return reduxState.demoSession.sessions;
    }

    return [];
  }

  saveDemoSessions(sessions: SessionInfo[]) {
    store.dispatch(setDemoSessions(sessions));
  }

  getCurrentTheme() {
    return store?.getState()?.common?.mode ?? "SYSTEM";
  }
  isDarkMode() {
    return store?.getState()?.common?.mode === "DARK";
  }

  getConfigCatFlag(key: ConfigCatFeatureFlag) {
    return store?.getState()?.configCat[key] ?? false;
  }
}

export default new HelperService();
